import { Injectable } from '@angular/core';

export interface ParsedAddress {
  text: string;
  street?: string;
  postalCode?: string;
  city?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AddressParserService {
  /** Straße + Hausnr., PLZ Ort */
  private readonly fullAddressRegex =
    /([A-Za-zäöüÄÖÜß][A-Za-zäöüÄÖÜß0-9\s.\-/]+?\d+\s*[a-zA-Z]?)\s*,?\s*(\d{5})\s+([A-Za-zäöüÄÖÜß][A-Za-zäöüÄÖÜß0-9\s.\-()]+)/gi;

  /** PLZ Ort (Fallback) */
  private readonly plzCityRegex =
    /(?:^|[\s,;|])(\d{5})\s+([A-Za-zäöüÄÖÜß][A-Za-zäöüÄÖÜß0-9\s.\-()]+)/gi;

  extractAddresses(text: string): ParsedAddress[] {
    if (!text || !text.trim()) {
      return [];
    }

    const found: ParsedAddress[] = [];
    const seen = new Set<string>();

    const add = (entry: ParsedAddress) => {
      const key = this.normalize(entry.text);
      if (!key || seen.has(key)) {
        return;
      }
      seen.add(key);
      found.push(entry);
    };

    let match: RegExpExecArray | null;
    const fullRe = new RegExp(this.fullAddressRegex.source, 'gi');
    while ((match = fullRe.exec(text)) !== null) {
      const street = match[1].trim().replace(/\s+/g, ' ');
      const postalCode = match[2].trim();
      const city = match[3].trim().replace(/\s+/g, ' ');
      add({
        text: `${street}, ${postalCode} ${city}`,
        street,
        postalCode,
        city
      });
    }

    const plzRe = new RegExp(this.plzCityRegex.source, 'gi');
    while ((match = plzRe.exec(text)) !== null) {
      const postalCode = match[1].trim();
      const city = match[2].trim().replace(/\s+/g, ' ');
      if (city.length < 2 || city.length > 60) {
        continue;
      }
      add({
        text: `${postalCode} ${city}`,
        postalCode,
        city
      });
    }

    text.split(/\r?\n/).map(line => line.trim()).filter(Boolean).forEach(line => {
      if (/\d{5}/.test(line) && line.length >= 8 && line.length <= 120) {
        add({ text: line.replace(/\s+/g, ' ') });
      }
    });

    return found;
  }

  private normalize(value: string): string {
    return value.toLowerCase().replace(/\s+/g, ' ').trim();
  }
}
